export default __webpack_public_path__ + "static/media/4717.83490398.png";